<template>

  <!--  row 1  -->
  <div class="d-flex justify-content-center mt-2 ">
    <div class="p-2 w-50  ">
      <label class="p-2"> نوع مشتری<span class="text-danger">*</span> </label>
      <select name="select" class="form-control" @change="selection($event)" v-model="myData.customer_type">
        <option value="" disabled>لطفا نوع مشتری رو انتخاب کنید</option>
        <option value="real" selected="selected">حقیقی</option>
        <option value="legal">حقوقی</option>
        <option value="immigrant">مهاجر</option>
      </select>
    </div>
  </div>
  <!--  row 2  -->
  <div v-if="statusSelection === 'immigrant'">
    <div class="d-flex d-flex-row mt-2  justify-content-center">
      <div class="p-2 w-50 ">
        <label>کد یکتا / اختصاصی <span class="text-danger">*</span></label>
        <input type="text" name="national" id="exclusive" maxlength="20" v-model="myData.exclusive"
               class="form-control" @keypress="types.ValidateNumber($event)"
               placeholder="کد یکتا / اختصاصی خود را واردکنید ">
      </div>
      <div class="p-2 w-50 ">
        <div class="input-group mb-3">
          <label class="input-group-text" for="inputGroupFile01">تصویر کارت شناسایی</label>
          <input type="file" id="file" ref="file" class="form-control" v-on:change="onChangeFileUpload($event)">
        </div>
      </div>
    </div>
  </div>
  <!--  row 3  -->
  <div v-if="statusSelection === 'legal'">
    <div class="d-flex d-flex-row mt-2  justify-content-center">
      <div class="p-2 w-50 mt-2">
        <label> کد اقتصادی / شناسه ملی <span class="text-danger">*</span></label>
        <input type="text" name="economic_Code" id="economic_Code" class="form-control"
               placeholder="کد اقتصادی / شناسه ملی " maxlength="12" minlength="11" v-model="myData.economic_Code"
               @keypress="types.ValidateNumber($event)">
      </div>

      <div class="p-2 w-50 mt-2">
        <label> نام شرکت (<span class="text-danger " style="font-size: 10px">لطفا  نام شرکت را وارد کنید</span>) <span
            class="text-danger">*</span></label>
        <input type="text" name="componeName" id="persianInput" class="form-control" v-model="myData.componeName"
               placeholder="لطفا نام شرکت خود را وارد کنید" v-on:keypress="types.ValidatePersian($event)">
      </div>
    </div>
  </div>
  <!--  row 4  -->
  <div class="d-flex d-flex-row mt-2  justify-content-center">
    <div class="p-2 w-50 ">
      <label>کد ملی <span class="text-danger">*</span></label>
      <input type="text" name="national" id="national" v-model="myData.national" class="form-control"
             placeholder="لطفا کدملی خود را وارد کنید" maxlength="10" @keypress="types.ValidateNumber($event)">
    </div>
    <div class="p-2 w-50 ">
      <label>ایمیل <span class="text-danger">*</span> </label>
      <input type="email" name="email" id="email" v-model="myData.email" class="form-control"
             placeholder="لطفا ادرس  ایمیل خود را وارد کنید">
    </div>
  </div>
  <!--  row 5  -->
  <div class="d-flex d-flex-row mt-2  justify-content-center">
    <div class="p-2 col-md-5 ">
      <label>شماره تلفن ثابت  <span class="text-danger">*</span></label>
      <input type="text" name="phone_number" id="phone_number" v-model="phone_number" class="form-control"
             placeholder="لطفاشماره تلفن ثابت  خود را وارد کنید" maxlength="8"
             @keypress="types.ValidateNumber($event)">
    </div>
    <div class="p-2 col-md-1">
      <label for="">کد شهر <span class="text-danger">*</span> </label>
      <input type="text" name="phone_number" id="phone_number" v-model="codCity" class="form-control"
             placeholder=" " maxlength="4" @keypress="types.ValidateNumber($event)">
    </div>
    <div class="p-2 w-50">
      <label>شماره همراه <span class="text-danger">*</span></label>
      <input type="text" name="mobile" id="mobile" v-model="myData.mobile" class="form-control"
             placeholder="لطفا شماره همراه خود وارد کنید" maxlength="11" @keypress="types.ValidateNumber($event)">
    </div>
  </div>
  <!--       row 6-->
  <div class="d-flex d-flex-row mt-2 justify-content-center">
    <div class="p-2 w-50">
      <label>استان <span class="text-danger">*</span> </label>
      <select name="Province" v-model="myData.province" class="form-control" @change="getStates($event)">
        <option value="" disabled>لطفا نام استان خود انتخاب کنید</option>
        <option v-for="(row , index) in provincess" :value="row">{{ row }}</option>
      </select>
    </div>
    <div class="p-2 w-50" name="city">
      <label>شهر <span class="text-danger">*</span></label>
      <select class="form-control" v-model="myData.city">
        <option value="" disabled>لطفا شهر خود انتخاب کنید</option>
        <option v-for="(row , index) in cities" :value="row">{{ row }}</option>
      </select>
    </div>
  </div>
  <!--  row 7  -->
  <div class="d-flex d-flex-row mt-2">
    <div class="p-2 w-100">
      <label>ادرس<span class="text-danger">*</span></label>
      <input type="text" class="form-control" v-model="myData.address" name="plaque"
             placeholder="لطفا اردس خود را وارد کنید" v-on:keypress="types.ValidatePersian($event)">
    </div>
  </div>
  <div class="d-flex d-flex-row mt-2 justify-content-center">
    <div class="p-2 w-50">
      <label> خیابان<span class="text-danger">*</span></label>
      <input type="text" class="form-control" name="avenue" v-model="myData.avenue" placeholder=" نام خیابان"
             v-on:keypress="types.ValidatePersian($event)">
    </div>
    <div class="p-2 w-50">
      <label for="">شماره پلاک <span class="text-danger">*</span></label>
      <input type="text" maxlength="5" class="form-control" v-model="myData.plaque" name="plaque"
             placeholder="شماره پلاک" @keypress="types.ValidateNumber($event)">
    </div>

  </div>
  <!--  row 8  -->
  <div class="d-flex d-flex-row mt-2 ">
    <div class="p-2 w-25">
      <label>کد پستی <span class="text-danger">*</span></label>
      <input type="text" name="postaـcode" id="postaـcode" v-model="myData.postaـcode" class="form-control"
             placeholder="لطفا کد پستی خود را وارد کنید" maxlength="10" @keypress="types.ValidateNumber($event)">
    </div>

  </div>
  <!--    row 10-->
  <div class="d-flex d-flex-row mt-3 justify-content-center">
    <div class="p-2 w-50  ">
      <button type="submit" @click="saveData()" class="btn btn-primary form-control">ثبت اطلاعات</button>
    </div>
  </div>
</template>

<script setup>
import datas from "../../../../config/city.json"
import {$ref} from "vue/macros";
import axios from "axios";
import {useToast} from "vue-toastification";
import {useRouter} from "vue-router";
import * as types from "../../../common/helpers/Typefa"

const router = useRouter()

const toast = useToast();

let provincess = $ref([]);
let cities = $ref([]);
let statusSelection = $ref()

let codCity = $ref();
let phone_number = $ref()

const myData = {
  "national": "",
  "mobile": "",
  "phone_number": "",
  "province": "",
  "avenue": "",
  "postaـcode": "",
  "address": "",
  "economic_Code": "",
  "city": "",
  "exclusive": "",
  "file": "",
  "customer_type": "",
  "email": "",
  "plaque": "",
  "componeName": "",
}


function getStates(e) {
  var desiredProvince = e.target.value; // مثال
  if (datas.hasOwnProperty(desiredProvince)) {
    cities = datas[desiredProvince].data_city.split(',').map(city => city.trim());

  } else {
    console.log("نام استان مورد نظر یافت نشد.");
  }
}

function getProvinces() {
  var desiredProvince = "provinces"; // مثال

  if (datas.hasOwnProperty(desiredProvince)) {
    provincess = datas[desiredProvince].data_provinces.split(',').map(provinces => provinces.trim());

  } else {
    toast.error("نام استان مورد نظر یافت نشد.");
  }
}

function selection(e) {
  return statusSelection = e.target.value;
}

async function saveData() {
  if (myData.codCity === "") {
    toast.error("لطفا پیش شماره تلفن ثابت را وارد کنید");
  }
  myData.phone_number = codCity + phone_number;
  console.log(myData);
  try {
    const res = await axios.post("agents/store", myData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });
    if (res.data.status === 'true') {
      toast.success(res.data.messages);
      await router.push({'path': '/agents/panel/checkout/'});

    }
  } catch (errors) {
    if (errors.response.status === 422) {
      Object.values(errors.response.data.errors).forEach(function (val, key) {
        toast.error(val[0]);
      });
    }
  }
}

function onChangeFileUpload(event) {
  console.log(event.target.files[0]);
  myData.file = event.target.files[0];
}

getProvinces()

</script>